import * as React from 'react';
import * as classNames from 'classnames';
import * as PropTypes from 'prop-types';
import * as qs from 'qs';

const LEFT_GAP = 'previous_elipse';
const RIGHT_GAP = 'next_elipse';
const PREVIOUS_PAGES = 'previous_pages';
const NEXT_PAGES = 'next_pages';
const ACTIVE = 'active';
const START_REL = 'start';

const range = function range(from, to) {
  const array = [];
  for (let i = from; i <= to; i++) {
    array.push(i);
  }
  return array;
};

class Pagination extends React.Component {
  static get defaultProps() {
    return {
      paginationWindow: 4,
      paginationPathname: '',
    };
  }

  constructor() {
    super();
    this.state = {};
    this.changePage = this.changePage.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ currentPage: nextProps.currentPage });
  }

  get currentPage() {
    return this.state.currentPage || this.props.currentPage;
  }

  validPage(page) {
    return page !== this.currentPage;
  }

  changePage(page, event) {
    if (!this.props.changePage) { return; }

    event.preventDefault();
    if (!this.validPage(page)) { return; }

    this.setState({ currentPage: page });
    this.props.changePage(page);
  }

  get window() {
    return this.props.window || window;
  }

  pageHref(pageNum) {
    const queryString = this.window.location.search.replace(/\?/, '');
    const queryObject = qs.parse(queryString);
    queryObject.page = pageNum;

    return `${this.props.paginationPathname}?${qs.stringify(queryObject)}`;
  }

  get middleRange() {
    let windowFrom = this.currentPage - this.props.paginationWindow;
    let windowTo = this.currentPage + this.props.paginationWindow;
    const totalPages = this.props.totalPages;

    if (windowTo > totalPages) {
      windowFrom -= windowTo - totalPages;
      windowTo = totalPages;
    }

    if (windowFrom < 1) {
      windowTo += 1 - windowFrom;
    }

    return range(
      Math.max(1, windowFrom + 1),
      Math.min(windowTo, totalPages),
    );
  }

  get leftRange() {
    if (this.props.paginationWindow < this.middleRange[0]) {
      return [1, LEFT_GAP]; // display first page and gap only
    }

    // display all pages from beginning to middle range
    return range(1, this.middleRange[0] - 1);
  }

  get rightRange() {
    const totalPages = this.props.totalPages;
    const endOfMiddleRange = this.middleRange[this.middleRange.length - 1];

    if (totalPages > endOfMiddleRange) {
      return [RIGHT_GAP]; // display gap only
    }

    // display all pages from middle range to end
    return range(endOfMiddleRange + 1, totalPages);
  }

  get pageNumbers() {
    return this.leftRange.concat(this.middleRange).concat(this.rightRange);
  }

  renderElipseLink(className) {
    return (
      <li key={className} className={classNames('dotspace', className)}>
        <a>{I18n.t('js.elipse')}</a>
      </li>
    );
  }

  renderPageNumberLink(pageNum, className, rel) {
    return (
      <li key={pageNum} className={classNames('page-num', className)}>
        <a
          href={this.pageHref(pageNum)}
          rel={rel}
          onClick={e => this.changePage(pageNum, e)}
        >
          {pageNum}
        </a>
      </li>
    );
  }

  renderPreviousButton() {
    if (this.currentPage === 1) { return null; }

    const newPage = this.currentPage - 1;
    return (
      <li key="prev" className="prev previous_page">
        <a href={this.pageHref(newPage)} rel="prev" onClick={e => this.changePage(newPage, e)}>
          <span className="fa fa-angle-left" />
          {I18n.t('js.previous')}
        </a>
      </li>
    );
  }

  renderNextButton() {
    if (this.currentPage === this.props.totalPages) { return null; }

    const newPage = this.currentPage + 1;
    return (
      <li key="next" className="next next_page">
        <a href={this.pageHref(newPage)} rel="next" onClick={e => this.changePage(newPage, e)}>
          {I18n.t('js.next')}
          <span className="fa fa-angle-right" />
        </a>
      </li>
    );
  }

  renderPages() {
    return this.pageNumbers.map((page) => {
      let className = '';
      let rel = '';

      if (page === LEFT_GAP || page === RIGHT_GAP) {
        return this.renderElipseLink(page);
      }

      if (page === this.currentPage) {
        className = ACTIVE;
        rel = START_REL;
      } else if (page < this.currentPage) {
        className = PREVIOUS_PAGES;
      } else if (page > this.currentPage) {
        className = NEXT_PAGES;
      }

      return this.renderPageNumberLink(page, className, rel);
    });
  }

  render() {
    if (!(this.props.totalPages > 1)) { return false; }

    return (
      <div className="align-center">
        <div className="pagination">
          <ul>
            {this.renderPreviousButton()}
            {this.renderPages()}
            {this.renderNextButton()}
          </ul>
        </div>
      </div>
    );
  }
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  changePage: PropTypes.func,
  window: PropTypes.object,
  paginationWindow: PropTypes.number,
  paginationPathname: PropTypes.string,
};

export default Pagination;



// WEBPACK FOOTER //
// ./javascripts/components/shared/pagination.jsx